import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { FormType } from "../../components/enums";
import { Url } from "../../router/enums";

import { ComponentId } from "./enums";

type AvailableOCForm =
  | FormType.OC_VEHICLE
  | FormType.OC_PROPERTY
  | FormType.OC_PERSON;

export type FormInput = {
  [ComponentId.IS_LEASE_CLIENT]: string;
  [ComponentId.OC_TYPE]: AvailableOCForm;
};

export type FormDataInputs = FormInput;

type WelcomeState = {
  data: FormInput;
  validated: boolean;
  redirect: string;
};

const initialState: WelcomeState = {
  data: {
    [ComponentId.IS_LEASE_CLIENT]: "",
    [ComponentId.OC_TYPE]: FormType.OC_VEHICLE,
  },
  validated: true,
  //JIRA LPPLWEBMOB-721
  redirect: Url.OC_VEHICLE_INTRODUCTORY,
};

const OCRedirect = {
  //JIRA LPPLWEBMOB-721
  [FormType.OC_VEHICLE]: Url.OC_VEHICLE_INTRODUCTORY,
  [FormType.OC_PROPERTY]: Url.OC_PROPERTY_PERPETRATOR,
  [FormType.OC_PERSON]: Url.OC_PERSON,
};

export const SLICE_NAME = "welcome";

const welcomeSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setData: (state) => {
      state.validated = true;
    },
    setIsClient(state, action: PayloadAction<string>) {
      state.data[ComponentId.IS_LEASE_CLIENT] = action.payload; // IS_LEASE_CLIENT - true/false
      //JIRA LPPLWEBMOB-750
      localStorage.removeItem("FormStartFromWelcome");
      localStorage.setItem("FormStartFromWelcome", "true");
      state.redirect = initialState.redirect;
      //JIRA LPPLWEBMOB-754
      state.data[ComponentId.OC_TYPE] = initialState.data[ComponentId.OC_TYPE];
      if (state.data[ComponentId.IS_LEASE_CLIENT] === "true") {
        state.redirect = Url.AC_VEHICLE;
      } else {
        //Domyslnie sciezka OC Pojazd - zmieniane w kolenym pytaniu przez akcje setOCType
        state.redirect = Url.OC_VEHICLE_INTRODUCTORY;
      }
    },
    setOCType(state, action: PayloadAction<AvailableOCForm>) {
      state.data[ComponentId.OC_TYPE] = action.payload; // OC_TYPE - oc/vehicle / oc/property / oc/person
      state.redirect = OCRedirect[action.payload];
    },
  },
});

export const {
  setData: setWelcomeFormData,
  setIsClient,
  setOCType,
} = welcomeSlice.actions;

export const { reducer } = welcomeSlice;
